declare namespace $ {

	export class $bog_merchquarium_button extends $mol_button_major {
		hidden( ): boolean
	}
	
}

//# sourceMappingURL=button.view.tree.d.ts.map